/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ProductLine;

(function (ProductLine) {
  ProductLine["GIT"] = "git";
  ProductLine["PROFESSIONAL_INDEMNITY"] = "professional-indemnity";
  ProductLine["RECRUITMENT_SCHEME"] = "recruitment-scheme";
})(ProductLine || (ProductLine = {}));